import React, { useState, forwardRef, useRef, useImperativeHandle, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Select from 'react-select'
import { useForm, Controller } from "react-hook-form";
import MoreTaxesGrid from '../aggrids/editable-aggrids/line-more-taxes-grid';
import Modal from 'react-bootstrap/Modal';
import SaleEntriesClassificationsGrid from "../aggrids/editable-aggrids/sale-entries-classifications-grid";

const SaleEntriesExtraModal = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const { getValues, control, setValue, formState: { errors } } = useForm();
    const [hasError, setHasError] = useState(false);
    const [initRowTotals, setInitRowTotals] = useState(0);
    const prodMoreTaxesGridRef = useRef();
    const saleEntryClassificationGridRef = useRef();
    const [showExtra, setShowExtra] = useState(false);
    const [rowTotalsConstraintDisplay, setRowTotalsConstraintDisplay] = useState("none")

    useEffect(() => {
        if (showExtra) {
            setValue("vatCategoryException", props.vatCategoryException || null);
        }
    }, [showExtra]);

    useImperativeHandle(ref, () => ({

        getRowsTotals() {
            return saleEntryClassificationGridRef.current.getRowsTotals();
        },
        getData() {
            var classificationsData = saleEntryClassificationGridRef.current.getData();
            var moretaxesData = prodMoreTaxesGridRef.current.getData();
            var taxesItems = prodMoreTaxesGridRef.current.transformData(moretaxesData, props.moreTaxesTypesOptions, props.moreTaxesOptions)
            var _items = {
                saleEntryClassifications: classificationsData,
                taxes: taxesItems,
                vatCategoryException: getValues().vatCategoryException
            }
            return _items;
        },
        setData(data) {
            saleEntryClassificationGridRef.current.setData(data);
        },
        showModal() {
            setShowExtra(true);
        },
        closeModal() {
            setShowExtra(false);
        },
        setRowTotalsConstraintDisplay(mess) {
            setRowTotalsConstraintDisplay(mess);
        }
    }));

    return (
        <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showExtra}
            dialogClassName="extras-modal"
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header >
                <Modal.Title>{t("extraLineInfo")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className="totalConstraintInfo">{props.rowTotalsMess}</span>
                {props.isInvoice00_1 ? <></> :
                    <div className="row">
                        <div style={{ display: rowTotalsConstraintDisplay }} id="classificationSumError" className="alert alert-danger" role="alert">
                            {t("classificationSumExtraError")}
                        </div>
                    </div>
                }

                <div className="row">
                    <div className="col-md-12">
                        <div className="text-center"><h5>{t("lineClassifications")}</h5></div>
                        <SaleEntriesClassificationsGrid
                            ref={saleEntryClassificationGridRef}
                            incomeClassCategories={props.incomeClassCategories}
                            myDataInvoiceType={props.myDataInvoiceType}
                            extraRowData={props.extraRowData}
                            rowTotals={props.rowTotals}
                            setRowTotalsConstraintDisplay={setRowTotalsConstraintDisplay}
                        >
                        </SaleEntriesClassificationsGrid>
                        <div style={{ display: "none" }}>
                            <hr></hr>
                            <div className="text-center"><h5>{t("moreTaxes")}</h5></div>
                            <MoreTaxesGrid
                                ref={prodMoreTaxesGridRef}
                                moreTaxesTypesOptions={props.moreTaxesTypesOptions}
                                moreTaxesOptions={props.moreTaxesOptions}
                                extraTaxes={props.extraTaxes}
                                extraRowData={props.extraRowData}
                                rowTotals={initRowTotals}
                            >
                            </MoreTaxesGrid>
                        </div>
                        <form>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 selectInputContainer form-group vatCategoryException">
                                        <label className="control-label inputlabel">
                                            {t('vatCategoryException')}
                                        </label>
                                        <Controller
                                            render={({ field }) => (
                                                <Select {...field}
                                                    isClearable={true} options={props.optionVatExceptionCategories}
                                                    className={`form-control ${errors.vatCategoryException ? 'is-invalid' : ''}`}
                                                    placeholder={t('Select')}
                                                >

                                                </Select>
                                            )}
                                            control={control}
                                            name="vatCategoryException"
                                            defaultValue={props.vatCategoryException}
                                        />


                                        <div className="invalid-feedback">{errors.withHoldTax?.message}</div>
                                    </div>

                                </div>
                            </div>

                        </form>

                    </div>
                    <div><br /></div>

                </div>

            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-skin" onClick={e => props.handleCloseExtra(e, false)}>{t("cancel")}</button>
                <button id="onExtras" className="btn btn-skin" onClick={e => props.handleCloseExtra(e, true)}>{t("accept")}</button>
            </Modal.Footer>
        </Modal>

    );
});
export default SaleEntriesExtraModal 